@if (type==='consultationSession' && consultationSession) {
  <chatV2-view title="Consultation"
    [chatUniqueObject]="consultationSession" [where]="{ user, consultationSession }"
  dataFunctionName="findConsultationSessionChat"></chatV2-view>
}
@if (type==='followUp' && followUp) {
  <chatV2-view title="Monthly Check-up" [chatUniqueObject]="followUp"
  [where]="{ user, followUp }" dataFunctionName="findFollowUpChat"></chatV2-view>
}
@if (type==='order' && order) {
  <chatV2-view title="Order" [chatUniqueObject]="order" [where]="{ user, order }"
  [disableChat]="true" dataFunctionName="findOrderChat"></chatV2-view>
}
@if (type==='supportTicket'
  && supportTicket) {
  <chatV2-view [title]='supportTicket?.get("title")' [chatUniqueObject]="supportTicket"
  [where]="{ user, supportTicket }" dataFunctionName="fetchSupportChat"></chatV2-view>
}